import { render, staticRenderFns } from "./ChangeCountry.vue?vue&type=template&id=5de09510&"
import script from "./ChangeCountry.vue?vue&type=script&lang=js&"
export * from "./ChangeCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports